export const KIDS_QUESTIONS_SLUG = 'detskie-voprosy';
export const MOBILE_MAX_WIDTH = 600;

export const DOSUG_LIMIT = 4;
